import Navbar from "../../components/Navbar";
import { useState } from "react";
import axios from "axios";
import { convertBase64, convertURL } from "../../imageHandler";

const placeholder = require("../../assets/placeholder.png");
const NewBathroom = () => {
  const data = {
    CAS: [
      "Francisco O. Santos Hall",
      "IBS and CPC Greenhouses and Annex Offices",
      "Molecular Biology and Biotechnology Laboratories",
      "Leopoldo B. Uichanco Hall",
      "New CAS Annex Building",
      "NEW CAS Annex Building II",
      "Old Humanities Building",
      "New Math Building",
      "Old Rural High School",
    ],
    CHE: ["Gil F. Saguitsuit Hall", "College of Human Ecology Complex"],
    CEM: [
      "REDREC Building",
      "School of Environmental Science and Management",
      "Armando M. Dalisay Hall",
      "Francisco M. Sacay Hall",
      "Department of Agribusiness Management",
      "CEM Dean's Office",
      "Nathaniel B. Tablante Hall",
    ],
    // Add more colleges as needed
  };

  const [name, setName] = useState("");
  const [college, setCollege] = useState(null);
  const [building, setBuilding] = useState(null);
  const [floor, setFloor] = useState("1");

  const [description, setDescription] = useState("");

  const [interiorPhoto, setInteriorPhoto] = useState(placeholder);
  const [buildingPhoto, setBuildingPhoto] = useState(placeholder);

  const [bidet, setBidet] = useState(false);
  const [tissuePaper, setTissuePaper] = useState(false);
  const [soap, setSoap] = useState(false);
  const [handDryer, setHandDryer] = useState(false);
  const [type, setType] = useState("");

  const [timeOpen, setTimeOpen] = useState("");
  const [timeClose, setTimeClose] = useState("");

  const colleges = Object.keys(data);
  const buildings = college ? data[college] : [];

  const handleCollegeChange = (e) => {
    setCollege(e.target.value);
    setBuilding(null);
  };

  const handleBuildingChange = (e) => {
    setBuilding(e.target.value);
  };
  // convert image to base64
  // const convertBase64 = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const fileReader = new FileReader();
  //     fileReader.readAsDataURL(file);

  //     fileReader.onload = () => {
  //       resolve(fileReader.result);
  //     };

  //     fileReader.onerror = (error) => {
  //       reject(error);
  //     };
  //   });
  // };

  const handleInteriorPhotoChange = async (e) => {
    setInteriorPhoto(await convertBase64(e.target.files[0]));
  };

  const handleBuildingPhotoChange = async (e) => {
    setBuildingPhoto(await convertBase64(e.target.files[0]));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // upload image
    const userData = await axios.post(
      "https://uplbidet-api.vercel.app/login-verification",
      {
        isAdmin: false,
      },
      { withCredentials: true }
    );

    // const interiorUrl = await axios.post("https://uplbidet-api.vercel.app/upload-image", {
    //   image: interiorPhoto,
    // });

    // const buildingUrl = await axios.post("https://uplbidet-api.vercel.app/upload-image", {
    //   image: buildingPhoto,
    // });

    const interiorUrl = await convertURL(interiorPhoto);
    const buildingUrl = await convertURL(buildingPhoto);

    var dateVariable = new Date();

    const cr = {
      user_id: userData.data.id,
      name: name,
      college: college,
      building: building,
      floor: floor,
      description: description,
      interior_photo: interiorUrl.data,
      building_photo: buildingUrl.data,
      bidet: bidet,
      tissue_paper: tissuePaper,
      soap: soap,
      hand_dryer: handDryer,
      type: type,
      time_open: timeOpen,
      time_close: timeClose,
      time_published: Date().toLocaleString(),
    };

    const res = await axios
      .post("https://uplbidet-api.vercel.app/api/cr", cr)
      .then((res) => {
        console.log(res);
        alert("New Bathroom has been posted")
        window.history.back();
      });
  };

  return (
    <div className="NewBathroom">
      <Navbar />
      <div className="main-content">
        <div className="container">
          <h1 className="heading">Add a New Comfort Room</h1>
          <div className="hr"></div>
          <div className="main-content-group">
            <form className="new-bathroom-form">
              <div className="image-upload">
                Building Image (Optional)
                <img alt="building" src={buildingPhoto}></img>
                <div className="file-container">
                  <input
                    type="file"
                    id="building-image"
                    name="building-image"
                    accept="image/*"
                    onChange={(e) => handleBuildingPhotoChange(e)}
                  ></input>
                </div>
                Interior Image (Optional)
                <img alt="interior" src={interiorPhoto}></img>
                <div className="file-container">
                  <input
                    type="file"
                    id="interior-image"
                    name="interior-image"
                    accept="image/*"
                    onChange={(e) => handleInteriorPhotoChange(e)}
                  ></input>
                </div>
              </div>
              <div className="bathroom-details">
                <label>Title</label>
                <input
                  type="text"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  placeholder="Listing Title"
                ></input>
                <label>Description</label>
                <textarea
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter comfort room description here..."
                ></textarea>
                <label>College</label>
                <div className="college-select">
                  {/* Colleges: CAFS, CAS, CEM, CVM, CDC, CEAT, CHE, CFNR */}
                  <select onChange={handleCollegeChange} value={college || ""}>
                    <option value="">Select a college</option>
                    {colleges.map((college) => (
                      <option key={college} value={college}>
                        {college}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="building-info-group">
                  <div className="bulding-group">
                    <label>Building</label>
                    <div className="building-select">
                      {/* TODO: LIST ALL BUILDINGS IN COLLEGES */}
                      <select
                        id="building"
                        onChange={handleBuildingChange}
                        value={building || ""}
                        disabled={!college}
                      >
                        <option value="" disabled>
                          Select a Building
                        </option>
                        {buildings.map((building) => (
                          <option key={building} value={building}>
                            {building}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="floor-group">
                  <label>Floor</label>
                  <div className="floor-select">
                    <select onChange={(e) => setFloor(e.target.value)}>
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                    </select>
                  </div>
                </div>
                <div className="bathroom-type">
                  <label>Type</label>
                  <div>
                    <input
                      type="radio"
                      name="type"
                      id="male"
                      value={"male"}
                      onChange={(e) => setType(e.target.value)}
                    />
                    <label htmlFor="male">Male</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="type"
                      id="female"
                      value={"female"}
                      onChange={(e) => setType(e.target.value)}
                    />
                    <label htmlFor="female">Female</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="type"
                      id="gender-neutral"
                      value={"gender-neutral"}
                      onChange={(e) => setType(e.target.value)}
                    />
                    <label htmlFor="gender-neutral">Gender Neutral</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="type"
                      id="pwd"
                      value={"pwd"}
                      onChange={(e) => setType(e.target.value)}
                    />
                    <label htmlFor="pwd">PWD</label>
                  </div>
                </div>
                <label>Amenities</label>
                <div className="details-select">
                  {/* Details: bidet, tissue, soap, hand dryer, pwd toilet */}
                  <div>
                    <input
                      type="checkbox"
                      id="bidet"
                      onChange={(e) => setBidet(!bidet)}
                    ></input>
                    <label htmlFor="bidet">Bidet</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="tissue"
                      onChange={(e) => setTissuePaper(!tissuePaper)}
                    ></input>
                    <label htmlFor="tissue">Tissue</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="soap"
                      onChange={(e) => setSoap(!soap)}
                    ></input>
                    <label htmlFor="soap">Soap</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="hand-dryer"
                      onChange={(e) => setHandDryer(!handDryer)}
                    ></input>
                    <label htmlFor="hand-dryer">Hand Dryer</label>
                  </div>
                </div>
                <label>Time Open (Optional)</label>
                <input
                  type="time"
                  onChange={(e) => setTimeOpen(e.target.value)}
                  value={timeOpen}
                  placeholder="Time Open"
                ></input>
                <label>Time Close (Optional)</label>
                <input
                  type="time"
                  onChange={(e) => setTimeClose(e.target.value)}
                  value={timeClose}
                  placeholder="Time Close"
                ></input>
              </div>
              <div className="form-buttons">
                <button className="cancel">CANCEL</button>
                <button className="add" onClick={handleSubmit}>
                  ADD
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewBathroom;
